import React from "react";
import { bool, node, string } from "prop-types";
import Paragraph from "../Paragraph";

const SimpleTemplateDescription = ({ className = "", center = true, children, ...props }) => {
	return (
		<Paragraph size="l" center={center} className={className} {...props}>
			{children}
		</Paragraph>
	);
};

SimpleTemplateDescription.propTypes = {
	className: string,
	center: bool,
	children: node.isRequired,
};

export default SimpleTemplateDescription;
